import * as ID from '@/constants/identifier';
import * as A from '@/constants/assets';
import { BOY_NAME, BOY_NAME_SHORT, GIRL_NAME, GIRL_NAME_SHORT, THE_BRIDE } from '.';

export const IMAGE_HELPER_LINK =
  'https://docs.google.com/document/d/1MFnWQQ3r52Xzq73163oHWwgdapF3UOrWkRUEUh2LVAE/edit?usp=sharing';
export const ASSETS_HELPER_LINK = '';

export const COLOR_DEFAULT_VALUES = [];

export const IMAGES_DEFAULT_VALUES = [
  { imageConstant: 'IMG_GIRL', imageName: 'Foto Bride', imageValue: A.IMG_GIRL },
  { imageConstant: 'IMG_MAN', imageName: 'Foto Groom', imageValue: A.IMG_MAN },
  { imageConstant: 'IMG_QR_COVER', imageName: 'Foto QR Card', imageValue: A.IMG_QR_COVER },
  {
    imageConstant: 'IMG_GALLERY_1',
    imageName: 'Foto Cover Galeri Luar 1',
    imageValue: A.IMG_GALLERY_1,
  },
  {
    imageConstant: 'IMG_GALLERY_2',
    imageName: 'Foto Cover Galeri Luar 2',
    imageValue: A.IMG_GALLERY_2,
  },
  {
    imageConstant: 'IMG_GALLERY_3',
    imageName: 'Foto Cover Galeri Luar 3',
    imageValue: A.IMG_GALLERY_3,
  },
  {
    imageConstant: 'IMG_GALLERY_COVER',
    imageName: 'Foto Cover Galeri Dalam',
    imageValue: A.IMG_GALLERY_COVER,
  },
  {
    imageConstant: 'BG_DESKTOP_VIEW',
    imageName: 'Background Desktop View',
    imageValue: A.BG_DESKTOP_VIEW,
  },
];

export const COUPLE_DEFAULT_VALUES = {
  coupleName: THE_BRIDE,
  brideName: GIRL_NAME_SHORT,
  groomName: BOY_NAME_SHORT,
  brideFullName: GIRL_NAME,
  groomFullName: BOY_NAME,
};

export const FONTS_DEFAULT_VALUES = [
  {
    fontCSS: 'heading',
    fontName: 'Heading',
    fontFamilyValue: 'Great Vibes',
    fontSizeValue: '46',
    fontWeightValue: 'regular',
    isFontItalic: false,
    fontCategory: 'heading',
    fontSectionId: ID.ID_DETAIL_SECTION,
  },
  {
    fontCSS: 'subHeading',
    fontName: 'Sub-heading',
    fontFamilyValue: 'Great Vibes',
    fontSizeValue: '46',
    fontWeightValue: 'regular',
    isFontItalic: false,
    fontCategory: 'heading',
    fontSectionId: 'invitato-detail-content',
  },
  {
    fontCSS: 'body',
    fontName: 'Body',
    fontFamilyValue: 'Cormorant Upright',
    fontSizeValue: '16',
    fontWeightValue: 'regular',
    isFontItalic: false,
    fontCategory: 'body',
    fontSectionId: ID.ID_DETAIL_SECTION,
  },
];
